import isValidUSPhoneNumber from '../isValidUSPhoneNumber/isValidUSPhoneNumber';
import removeLeadingOne from '../removeLeadingOne/removeLeadingOne';
/**
 * @var matchNonDigits
 * @type {RegExp}
 * @access private
 * @desc Regular expression used to match non digits.
 */
const matchNonDigits: RegExp = /\D/g;

/**
 * Formats a string containing 10 or 11 numbers to look like a US phone number.
 * However, if the string does not contain the correct amount of digits, a
 * blank string is returned
 *
 * Examples:
 * - 10 numbers: "1234567890" becomes "(123)-456-7890".
 * - 10 numbers: "a1b2c3d4e5f6g7h8i9j0k" becomes "(123)-456-7890".
 * - 11 numbers: "+1 123-456-7890" becomes "(123)-456-7890"
 *
 * However, if the supplied string doesn't contain exactly 10 digits, an empty
 * string is returned. (not sure why... seems unhelpful.  grandfathered in.)
 *
 * Examples:
 * - "123" becomes ""
 *
 *
 * @param {String} number - the phone number.
 * @returns {String} - formatted phone number or a blank string.
 */
const formatUSPhoneNumber = (number?: string | null): string => {
  if (typeof number === 'string' && number.length > 0) {
    if (isValidUSPhoneNumber(number) === true) {
      const onlyDigits: string = removeLeadingOne(
        number.replace(matchNonDigits, '')
      );
      return `(${onlyDigits.substring(0, 3)}) ${onlyDigits.substring(
        6,
        3
      )}-${onlyDigits.substring(10, 6)}`;
    }

    return '';
  }

  return '';
};

export default formatUSPhoneNumber;
